// Redux Action

import {
  BANK_LIST_REQUEST,
  BANK_LIST_SUCCESS,
  BANK_LIST_FAIL,
  BANK_TRANSACTION_LIST_REQUEST,
  BANK_TRANSACTION_LIST_SUCCESS,
  BANK_TRANSACTION_LIST_FAIL,
  BANK_ALL_TRANSACTION_LIST_REQUEST,
  BANK_ALL_TRANSACTION_LIST_SUCCESS,
  BANK_ALL_TRANSACTION_LIST_FAIL,
  BANK_UNALLOCATED_TRANSACTION_LIST_REQUEST,
  BANK_UNALLOCATED_TRANSACTION_LIST_SUCCESS,
  BANK_UNALLOCATED_TRANSACTION_LIST_FAIL,
  ITEM_ALLOCATION_LIST_REQUEST,
  ITEM_ALLOCATION_LIST_SUCCESS,
  ITEM_ALLOCATION_LIST_FAIL,
  CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_REQUEST,
  CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_SUCCESS,
  CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_FAIL,
  UNCLEAR_TRANSACTION_REQUEST,
  UNCLEAR_TRANSACTION_SUCCESS,
  UNCLEAR_TRANSACTION_FAIL,
  CUSTOMER_SEARCH_ALL_TRANSACTIONS_REQUEST,
  CUSTOMER_SEARCH_ALL_TRANSACTIONS_SUCCESS,
  CUSTOMER_SEARCH_ALL_TRANSACTIONS_FAIL,
  SUPPLIER_SEARCH_ALL_TRANSACTIONS_REQUEST,
  SUPPLIER_SEARCH_ALL_TRANSACTIONS_SUCCESS,
  SUPPLIER_SEARCH_ALL_TRANSACTIONS_FAIL,
  CREATE_SINGLE_BANK_TRANSACTION_REQUEST,
  CREATE_SINGLE_BANK_TRANSACTION_SUCCESS,
  CREATE_SINGLE_BANK_TRANSACTION_FAIL,
  BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_REQUEST,
  BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_SUCCESS,
  BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_FAIL,
  BANK_UPLOAD_TRANSACTIONS_REQUEST,
  BANK_UPLOAD_TRANSACTIONS_SUCCESS,
  BANK_UPLOAD_TRANSACTIONS_FAIL,
  BANK_ASSIGNED_ONLY_TRANSACTION_LIST_REQUEST,
  BANK_ASSIGNED_ONLY_TRANSACTION_LIST_SUCCESS,
  BANK_ASSIGNED_ONLY_TRANSACTION_LIST_FAIL,
  BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_REQUEST,
  BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_SUCCESS,
  BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_FAIL,
  BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_REQUEST,
  BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_SUCCESS,
  BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_FAIL,
  CREATE_BANK,
  CREATE_BANK_SUCCESS,
  CREATE_BANK_FAIL,
  UPDATE_BANK,
  UPDATE_BANK_SUCCESS,
  UPDATE_BANK_FAIL,
  DELETE_BANK,
  DELETE_BANK_SUCCESS,
  DELETE_BANK_FAIL,
  SYNC_BANK_TRANSACTIONS,
  SYNC_BANK_TRANSACTIONS_SUCCESS,
  SYNC_BANK_TRANSACTIONS_FAIL,
  SYNC_BANK_TRANSACTIONS_RESET,
  SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_REQUEST,
  SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_SUCCESS,
  SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_FAIL,
  SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_REQUEST,
  SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_SUCCESS,
  SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_FAIL,
  GET_BANK_ACCOUNT_STATUS_LIST,
  GET_BANK_ACCOUNT_STATUS_LIST_SUCCESS,
  GET_BANK_ACCOUNT_STATUS_LIST_FAIL,
  BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_REQUEST,
  BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_SUCCESS,
  BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_FAIL,
  GET_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST,
  GET_MANUAL_BANK_TRANSACTION_DETAILS_SUCCESS,
  GET_MANUAL_BANK_TRANSACTION_DETAILS_FAIL,
  UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST,
  UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_SUCCESS,
  UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_FAIL,
  BANK_ACCOUNT_PROVIDER_LIST_REQUEST,
  BANK_ACCOUNT_PROVIDER_LIST_SUCCESS,
  BANK_ACCOUNT_PROVIDER_LIST_FAIL,
  GET_BANK_ACCOUNT_STATUS_DATA_REQUEST,
  GET_BANK_ACCOUNT_STATUS_DATA_SUCCESS,
  GET_BANK_ACCOUNT_STATUS_DATA_FAIL,
  CREATE_BANK_ACCOUNT_STATUS_REQUEST,
  CREATE_BANK_ACCOUNT_STATUS_SUCCESS,
  CREATE_BANK_ACCOUNT_STATUS_FAIL,
  UPDATE_BANK_ACCOUNT_STATUS_REQUEST,
  UPDATE_BANK_ACCOUNT_STATUS_SUCCESS,
  UPDATE_BANK_ACCOUNT_STATUS_FAIL,
  DELETE_BANK_ACCOUNT_STATUS_REQUEST,
  DELETE_BANK_ACCOUNT_STATUS_SUCCESS,
  DELETE_BANK_ACCOUNT_STATUS_FAIL,
  BANK_ACCOUNT_FEED_CONNECTION_REQUEST,
  BANK_ACCOUNT_FEED_CONNECTION_SUCCESS,
  BANK_ACCOUNT_FEED_CONNECTION_FAIL,
  BANK_ACCOUNT_FEED_MAP_ACCOUNTS_REQUEST,
  BANK_ACCOUNT_FEED_MAP_ACCOUNTS_SUCCESS,
  BANK_ACCOUNT_FEED_MAP_ACCOUNTS_FAIL,
  BANK_TRANSACTION_IMPORT_REQUEST,
  BANK_TRANSACTION_IMPORT_SUCCESS,
  BANK_TRANSACTION_IMPORT_FAIL,
  BANK_TRANSACTION_ALLOCATION_UNCLEAR_REQUEST,
  BANK_TRANSACTION_ALLOCATION_UNCLEAR_SUCCESS,
  BANK_TRANSACTION_ALLOCATION_UNCLEAR_FAIL,
  BANK_TRANSACTION_ALLOCATION_SPLIT_REQUEST,
  BANK_TRANSACTION_ALLOCATION_SPLIT_SUCCESS,
  BANK_TRANSACTION_ALLOCATION_SPLIT_FAIL,
  BANK_ACCOUNT_FEED_RECONNECTION_REQUEST,
  BANK_ACCOUNT_FEED_RECONNECTION_SUCCESS,
  BANK_ACCOUNT_FEED_RECONNECTION_FAIL,
  CLEARING_DOCUMENT_SEARCH_REQUEST,
  CLEARING_DOCUMENT_SEARCH_SUCCESS,
  CLEARING_DOCUMENT_SEARCH_FAIL,
  BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_REQUEST,
  BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_SUCCESS,
  BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_FAIL,
  BANK_ACCOUNT_ATTACHMENT_SEARCH,
  BANK_ACCOUNT_ATTACHMENT_SEARCH_SUCCESS,
  BANK_ACCOUNT_ATTACHMENT_SEARCH_FAILURE,
  BANK_ACCOUNT_ATTACHMENT_DELETE,
  BANK_ACCOUNT_ATTACHMENT_DELETE_SUCCESS,
  BANK_ACCOUNT_ATTACHMENT_DELETE_FAILURE,
  BANK_ACCOUNT_STATEMENT_SEARCH,
  BANK_ACCOUNT_STATEMENT_SEARCH_SUCCESS,
  BANK_ACCOUNT_STATEMENT_SEARCH_FAILURE,
  BANK_ACCOUNT_STATEMENT_DELETE,
  BANK_ACCOUNT_STATEMENT_DELETE_SUCCESS,
  BANK_ACCOUNT_STATEMENT_DELETE_FAILURE,
} from "./actionType";

// Redux Actions Bank List

export const getBankList = () => {
  return {
    type: BANK_LIST_REQUEST,
  };
};

export const getBankListSuccess = (bankList) => {
  return {
    type: BANK_LIST_SUCCESS,
    payload: bankList,
  };
};

export const getBankListError = (error) => {
  return {
    type: BANK_LIST_FAIL,
    payload: error,
  };
};

// Redux Actions Bank Transaction List

export const getBankTransactionList = (id) => {
  return {
    type: BANK_TRANSACTION_LIST_REQUEST,
    payload: id,
  };
};

export const getBankTransactionListSuccess = (bankTransactionList) => {
  return {
    type: BANK_TRANSACTION_LIST_SUCCESS,
    payload: bankTransactionList,
  };
};

export const getBankTransactionListError = (error) => {
  return {
    type: BANK_TRANSACTION_LIST_FAIL,
    payload: error,
  };
};

// Redux Actions All Banks Transaction List

export const getAllBankTransactionList = () => {
  return {
    type: BANK_ALL_TRANSACTION_LIST_REQUEST,
  };
};

export const getAllBankTransactionListSuccess = (allBankTransactionList) => {
  return {
    type: BANK_ALL_TRANSACTION_LIST_SUCCESS,
    payload: allBankTransactionList,
  };
};

export const getAllBankTransactionListError = (error) => {
  return {
    type: BANK_ALL_TRANSACTION_LIST_FAIL,
    payload: error,
  };
};

// Redux Actions UnAllocated Bank Transactions List

export const getUnAllocatedBankTransactionList = () => {
  return {
    type: BANK_UNALLOCATED_TRANSACTION_LIST_REQUEST,
  };
};

export const getUnAllocatedBankTransactionListSuccess = (
  unAllocatedBankTransactionList
) => {
  return {
    type: BANK_UNALLOCATED_TRANSACTION_LIST_SUCCESS,
    payload: unAllocatedBankTransactionList,
  };
};

export const getUnAllocatedBankTransactionListError = (error) => {
  return {
    type: BANK_UNALLOCATED_TRANSACTION_LIST_FAIL,
    payload: error,
  };
};

// Item Allocation List

export const getItemAllocationList = (id) => {
  return {
    type: ITEM_ALLOCATION_LIST_REQUEST,
    payload: id,
  };
};

export const getItemAllocationListSuccess = (itemAllocationList) => {
  return {
    type: ITEM_ALLOCATION_LIST_SUCCESS,
    payload: itemAllocationList,
  };
};

export const getItemAllocationListError = (error) => {
  return {
    type: ITEM_ALLOCATION_LIST_FAIL,
    payload: error,
  };
};

// Clear Allocated Transaction and Items

export const clearAllocatedTransactionAndItems = (id) => {
  return {
    type: CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_REQUEST,
    payload: id,
  };
};

export const clearAllocatedTransactionAndItemsSuccess = (
  clearAllocatedTransactionAndItems
) => {
  return {
    type: CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_SUCCESS,
    payload: clearAllocatedTransactionAndItems,
  };
};

export const clearAllocatedTransactionAndItemsError = (error) => {
  return {
    type: CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_FAIL,
    payload: error,
  };
};

// Unclear Transaction

export const unclearTransaction = (id) => {
  return {
    type: UNCLEAR_TRANSACTION_REQUEST,
    payload: id,
  };
};

export const unclearTransactionSuccess = (unclearTransaction) => {
  return {
    type: UNCLEAR_TRANSACTION_SUCCESS,
    payload: unclearTransaction,
  };
};

export const unclearTransactionError = (error) => {
  return {
    type: UNCLEAR_TRANSACTION_FAIL,
    payload: error,
  };
};

// Single Customer Search All Transactions

export const customerSearchAllTransactions = (id) => {
  return {
    type: CUSTOMER_SEARCH_ALL_TRANSACTIONS_REQUEST,
    payload: id,
  };
};

export const customerSearchAllTransactionsSuccess = (
  customerSearchAllTransactions
) => {
  return {
    type: CUSTOMER_SEARCH_ALL_TRANSACTIONS_SUCCESS,
    payload: customerSearchAllTransactions,
  };
};

export const customerSearchAllTransactionsError = (error) => {
  return {
    type: CUSTOMER_SEARCH_ALL_TRANSACTIONS_FAIL,
    payload: error,
  };
};

// Single Supplier Search All Transactions

export const supplierSearchAllTransactions = (id) => {
  return {
    type: SUPPLIER_SEARCH_ALL_TRANSACTIONS_REQUEST,
    payload: id,
  };
};

export const supplierSearchAllTransactionsSuccess = (data) => {
  return {
    type: SUPPLIER_SEARCH_ALL_TRANSACTIONS_SUCCESS,
    payload: data,
  };
};
export const supplierSearchAllTransactionsError = (error) => {
  return {
    type: SUPPLIER_SEARCH_ALL_TRANSACTIONS_FAIL,
    payload: error,
  };
};

// Create Single Bank Transaction

export const createSingleBankTransaction = (data) => {
  return {
    type: CREATE_SINGLE_BANK_TRANSACTION_REQUEST,
    payload: data,
  };
};

export const createSingleBankTransactionSuccess = (data) => {
  return {
    type: CREATE_SINGLE_BANK_TRANSACTION_SUCCESS,
    payload: data,
  };
};

export const createSingleBankTransactionError = (error) => {
  return {
    type: CREATE_SINGLE_BANK_TRANSACTION_FAIL,
    payload: error,
  };
};

// Bank Single Customer Transaction PDF Statement

export const bankSingleCustomerTransactionPDFStatement = (id) => {
  return {
    type: BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_REQUEST,
    payload: id,
  };
};

export const bankSingleCustomerTransactionPDFStatementSuccess = (data) => {
  return {
    type: BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_SUCCESS,
    payload: data,
  };
};

export const bankSingleCustomerTransactionPDFStatementError = (error) => {
  return {
    type: BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_FAIL,
    payload: error,
  };
};

// Bank Upload Transactions file

export const bankUploadTransactionsFile = (data) => {
  return {
    type: BANK_UPLOAD_TRANSACTIONS_REQUEST,
    payload: data,
  };
};

export const bankUploadTransactionsFileSuccess = (data) => {
  return {
    type: BANK_UPLOAD_TRANSACTIONS_SUCCESS,
    payload: data,
  };
};

export const bankUploadTransactionsFileError = (error) => {
  return {
    type: BANK_UPLOAD_TRANSACTIONS_FAIL,
    payload: error,
  };
};

// Assigned Only Bank Transactions list

export const getAssignedOnlyBankTransactionList = () => {
  return {
    type: BANK_ASSIGNED_ONLY_TRANSACTION_LIST_REQUEST,
  };
};

export const getAssignedOnlyBankTransactionListSuccess = (
  assignedOnlyBankTransactionList
) => {
  return {
    type: BANK_ASSIGNED_ONLY_TRANSACTION_LIST_SUCCESS,
    payload: assignedOnlyBankTransactionList,
  };
};

export const getAssignedOnlyBankTransactionListError = (error) => {
  return {
    type: BANK_ASSIGNED_ONLY_TRANSACTION_LIST_FAIL,
    payload: error,
  };
};

// Bank Assign transaction to customer

export const bankAssignTransactionToCustomer = (data) => {
  return {
    type: BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_REQUEST,
    payload: data,
  };
};

export const bankAssignTransactionToCustomerSuccess = (data) => {
  return {
    type: BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_SUCCESS,
    payload: data,
  };
};

export const bankAssignTransactionToCustomerError = (error) => {
  return {
    type: BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_FAIL,
    payload: error,
  };
};

// Bank Unassign transaction from customer

export const bankUnassignTransactionFromCustomer = (data) => {
  return {
    type: BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_REQUEST,
    payload: data,
  };
};

export const bankUnassignTransactionFromCustomerSuccess = (data) => {
  return {
    type: BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_SUCCESS,
    payload: data,
  };
};

export const bankUnassignTransactionFromCustomerError = (error) => {
  return {
    type: BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_FAIL,
    payload: error,
  };
};

// Create bank

export const createBank = (data) => {
  return {
    type: CREATE_BANK,
    payload: data,
  };
};
export const createBankSuccess = (data) => {
  return {
    type: CREATE_BANK_SUCCESS,
    payload: data,
  };
};
export const createBankError = (error) => {
  return {
    type: CREATE_BANK_FAIL,
    payload: error,
  };
};

// Update Bank

export const updateBank = (data) => {
  return {
    type: UPDATE_BANK,
    payload: data,
  };
};
export const updateBankSuccess = (data) => {
  return {
    type: UPDATE_BANK_SUCCESS,
    payload: data,
  };
};
export const updateBankError = (error) => {
  return {
    type: UPDATE_BANK_FAIL,
    payload: error,
  };
};

// DELETE Bank

export const deleteBank = (id) => {
  return {
    type: DELETE_BANK,
    payload: id,
  };
};
export const deleteBankSuccess = (data) => {
  return {
    type: DELETE_BANK_SUCCESS,
    payload: data,
  };
};

export const deleteBankError = (error) => {
  return {
    type: DELETE_BANK_FAIL,
    payload: error,
  };
};

// SYNC BANK TRANSACTIONS — id = bank account id
export const syncBankTransactions = (id) => ({
  type: SYNC_BANK_TRANSACTIONS,
  payload: id,
});
export const syncBankTransactionsSuccess = (data) => ({
  type: SYNC_BANK_TRANSACTIONS_SUCCESS,
  payload: data,
});
export const syncBankTransactionsError = (error) => ({
  type: SYNC_BANK_TRANSACTIONS_FAIL,
  payload: error,
});
export const syncBankTransactionsReset = () => ({
  type: SYNC_BANK_TRANSACTIONS_RESET,
});

// Single Customer Transaction Open Items PDF Statement

export const singleCustomerTransactionOpenItemsPDFStatement = (id) => {
  return {
    type: SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_REQUEST,
    payload: id,
  };
};

export const singleCustomerTransactionOpenItemsPDFStatementSuccess = (data) => {
  return {
    type: SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_SUCCESS,
    payload: data,
  };
};

export const singleCustomerTransactionOpenItemsPDFStatementError = (error) => {
  return {
    type: SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_FAIL,
    payload: error,
  };
};

//  Single Customer Transaction All Items PDF Statement

export const singleCustomerTransactionAllItemsPDFStatement = (id) => {
  return {
    type: SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_REQUEST,
    payload: id,
  };
};

export const singleCustomerTransactionAllItemsPDFStatementSuccess = (data) => {
  return {
    type: SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_SUCCESS,
    payload: data,
  };
};

export const singleCustomerTransactionAllItemsPDFStatementError = (error) => {
  return {
    type: SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_FAIL,
    payload: error,
  };
};

//GET_BANK_ACCOUNT_STATUS_LIST
export const getBankAccountStatusList = () => {
  return {
    type: GET_BANK_ACCOUNT_STATUS_LIST,
  };
};
export const getBankAccountStatusListSuccess = (data) => {
  return {
    type: GET_BANK_ACCOUNT_STATUS_LIST_SUCCESS,
    payload: data,
  };
};

export const getBankAccountStatusListError = (error) => {
  return {
    type: GET_BANK_ACCOUNT_STATUS_LIST_FAIL,
    payload: error,
  };
};

// Bank Transaction Allocation Delete Transaction
export const bankTransactionAllocationDeleteTransaction = (data) => {
  return {
    type: BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_REQUEST,
    payload: data,
  };
};
export const bankTransactionAllocationDeleteTransactionSuccess = (data) => {
  return {
    type: BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_SUCCESS,
    payload: data,
  };
};

export const bankTransactionAllocationDeleteTransactionError = (error) => {
  return {
    type: BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_FAIL,
    payload: error,
  };
};

//GET_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST
export const getManualBankTransactionDetails = (data) => {
  return {
    type: GET_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST,
    payload: data,
  };
};
export const getManualBankTransactionDetailsSuccess = (data) => {
  return {
    type: GET_MANUAL_BANK_TRANSACTION_DETAILS_SUCCESS,
    payload: data,
  };
};

export const getManualBankTransactionDetailsError = (error) => {
  return {
    type: GET_MANUAL_BANK_TRANSACTION_DETAILS_FAIL,
    payload: error,
  };
};

//UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST
export const updateManualBankTransactionDetails = (data) => {
  return {
    type: UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST,
    payload: data,
  };
};

export const updateManualBankTransactionDetailsSuccess = (data) => {
  return {
    type: UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_SUCCESS,
    payload: data,
  };
};

export const updateManualBankTransactionDetailsError = (error) => {
  return {
    type: UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_FAIL,
    payload: error,
  };
};
//BANK_ACCOUNT_PROVIDER_LIST_REQUEST
export const bankAccountProviderList = () => {
  return {
    type: BANK_ACCOUNT_PROVIDER_LIST_REQUEST,
  };
};

export const bankAccountProviderListSuccess = (data) => {
  return {
    type: BANK_ACCOUNT_PROVIDER_LIST_SUCCESS,
    payload: data,
  };
};

export const bankAccountProviderListError = (error) => {
  return {
    type: BANK_ACCOUNT_PROVIDER_LIST_FAIL,
    payload: error,
  };
};

//GET_BANK_ACCOUNT_STATUS_DATA_REQUEST
export const getBankAccountStatusData = (data) => {
  return {
    type: GET_BANK_ACCOUNT_STATUS_DATA_REQUEST,
    payload: data,
  };
};

export const getBankAccountStatusDataSuccess = (data) => {
  return {
    type: GET_BANK_ACCOUNT_STATUS_DATA_SUCCESS,
    payload: data,
  };
};

export const getBankAccountStatusDataError = (error) => {
  return {
    type: GET_BANK_ACCOUNT_STATUS_DATA_FAIL,
    payload: error,
  };
};

//CREATE_BANK_ACCOUNT_STATUS_REQUEST
export const createBankAccountStatus = (data) => {
  return {
    type: CREATE_BANK_ACCOUNT_STATUS_REQUEST,
    payload: data,
  };
};

export const createBankAccountStatusSuccess = (data) => {
  return {
    type: CREATE_BANK_ACCOUNT_STATUS_SUCCESS,
    payload: data,
  };
};

export const createBankAccountStatusError = (error) => {
  return {
    type: CREATE_BANK_ACCOUNT_STATUS_FAIL,
    payload: error,
  };
};

//UPDATE_BANK_ACCOUNT_STATUS_REQUEST
export const updateBankAccountStatus = (data) => {
  return {
    type: UPDATE_BANK_ACCOUNT_STATUS_REQUEST,
    payload: data,
  };
};

export const updateBankAccountStatusSuccess = (data) => {
  return {
    type: UPDATE_BANK_ACCOUNT_STATUS_SUCCESS,
    payload: data,
  };
};

export const updateBankAccountStatusError = (error) => {
  return {
    type: UPDATE_BANK_ACCOUNT_STATUS_FAIL,
    payload: error,
  };
};

//DELETE_BANK_ACCOUNT_STATUS_REQUEST
export const deleteBankAccountStatus = (data) => {
  return {
    type: DELETE_BANK_ACCOUNT_STATUS_REQUEST,
    payload: data,
  };
};

export const deleteBankAccountStatusSuccess = (data) => {
  return {
    type: DELETE_BANK_ACCOUNT_STATUS_SUCCESS,
    payload: data,
  };
};

export const deleteBankAccountStatusError = (error) => {
  return {
    type: DELETE_BANK_ACCOUNT_STATUS_FAIL,
    payload: error,
  };
};

//BANK_ACCOUNT_FEED_CONNECTION_REQUEST
export const bankAccountFeedConnection = (data) => {
  return {
    type: BANK_ACCOUNT_FEED_CONNECTION_REQUEST,
    payload: data,
  };
};

export const bankAccountFeedConnectionSuccess = (data) => {
  return {
    type: BANK_ACCOUNT_FEED_CONNECTION_SUCCESS,
    payload: data,
  };
};

export const bankAccountFeedConnectionError = (error) => {
  return {
    type: BANK_ACCOUNT_FEED_CONNECTION_FAIL,
    payload: error,
  };
};

//BANK_ACCOUNT_FEED_MAP_ACCOUNTS_REQUEST
export const bankAccountFeedMapAccounts = (data) => {
  return {
    type: BANK_ACCOUNT_FEED_MAP_ACCOUNTS_REQUEST,
    payload: data,
  };
};

export const bankAccountFeedMapAccountsSuccess = (data) => {
  return {
    type: BANK_ACCOUNT_FEED_MAP_ACCOUNTS_SUCCESS,
    payload: data,
  };
};

export const bankAccountFeedMapAccountsError = (error) => {
  return {
    type: BANK_ACCOUNT_FEED_MAP_ACCOUNTS_FAIL,
    payload: error,
  };
};

//BANK_TRANSACTION_IMPORT_REQUEST
export const bankTransactionImport = (data) => {
  return {
    type: BANK_TRANSACTION_IMPORT_REQUEST,
    payload: data,
  };
};

export const bankTransactionImportSuccess = (data) => {
  return {
    type: BANK_TRANSACTION_IMPORT_SUCCESS,
    payload: data,
  };
};

export const bankTransactionImportError = (error) => {
  return {
    type: BANK_TRANSACTION_IMPORT_FAIL,
    payload: error,
  };
};

//BANK_TRANSACTION_ALLOCATION_UNCLEAR_REQUEST
export const bankTransactionAllocationUnclear = (data) => {
  return {
    type: BANK_TRANSACTION_ALLOCATION_UNCLEAR_REQUEST,
    payload: data,
  };
};

export const bankTransactionAllocationUnclearSuccess = (data) => {
  return {
    type: BANK_TRANSACTION_ALLOCATION_UNCLEAR_SUCCESS,
    payload: data,
  };
};

export const bankTransactionAllocationUnclearError = (error) => {
  return {
    type: BANK_TRANSACTION_ALLOCATION_UNCLEAR_FAIL,
    payload: error,
  };
};

//BANK_TRANSACTION_ALLOCATION_SPLIT_REQUEST
export const bankTransactionAllocationSplit = (data) => {
  return {
    type: BANK_TRANSACTION_ALLOCATION_SPLIT_REQUEST,
    payload: data,
  };
};

export const bankTransactionAllocationSplitSuccess = (data) => {
  return {
    type: BANK_TRANSACTION_ALLOCATION_SPLIT_SUCCESS,
    payload: data,
  };
};

export const bankTransactionAllocationSplitError = (error) => {
  return {
    type: BANK_TRANSACTION_ALLOCATION_SPLIT_FAIL,
    payload: error,
  };
};

//BANK_ACCOUNT_FEED_RECONNECTION_REQUEST
export const bankAccountFeedReconnection = (data) => {
  return {
    type: BANK_ACCOUNT_FEED_RECONNECTION_REQUEST,
    payload: data,
  };
};
export const bankAccountFeedReconnectionSuccess = (data) => {
  return {
    type: BANK_ACCOUNT_FEED_RECONNECTION_SUCCESS,
    payload: data,
  };
};
export const bankAccountFeedReconnectionError = (error) => {
  return {
    type: BANK_ACCOUNT_FEED_RECONNECTION_FAIL,
    payload: error,
  };
};

//CLEARING_DOCUMENT_SEARCH_REQUEST
export const clearingDocumentSearch = (data) => {
  return {
    type: CLEARING_DOCUMENT_SEARCH_REQUEST,
    payload: data,
  };
};
export const clearingDocumentSearchSuccess = (data) => {
  return {
    type: CLEARING_DOCUMENT_SEARCH_SUCCESS,
    payload: data,
  };
};
export const clearingDocumentSearchError = (error) => {
  return {
    type: CLEARING_DOCUMENT_SEARCH_FAIL,
    payload: error,
  };
};

//BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_REQUEST
export const bankTransactionAllocationAutoClear = (data) => {
  return {
    type: BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_REQUEST,
    payload: data,
  };
};

export const bankTransactionAllocationAutoClearSuccess = (data) => {
  return {
    type: BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_SUCCESS,
    payload: data,
  };
};

export const bankTransactionAllocationAutoClearError = (error) => {
  return {
    type: BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_FAIL,
    payload: error,
  };
};

// Bank Account Attachment (bank statements)
// Search - data = [{ bankaccountattachment_data: { BankAccount_Id } }]
export const searchBankAccountAttachment = (data) => {
  return {
    type: BANK_ACCOUNT_ATTACHMENT_SEARCH,
    payload: data,
  };
};

export const searchBankAccountAttachmentSuccess = (data) => {
  return {
    type: BANK_ACCOUNT_ATTACHMENT_SEARCH_SUCCESS,
    payload: data,
  };
};

export const searchBankAccountAttachmentFailure = (error) => {
  return {
    type: BANK_ACCOUNT_ATTACHMENT_SEARCH_FAILURE,
    payload: error,
  };
};

// Delete - data = [Id, ...]
export const deleteBankAccountAttachment = (data) => {
  return {
    type: BANK_ACCOUNT_ATTACHMENT_DELETE,
    payload: data,
  };
};

export const deleteBankAccountAttachmentSuccess = (data) => {
  return {
    type: BANK_ACCOUNT_ATTACHMENT_DELETE_SUCCESS,
    payload: data,
  };
};

export const deleteBankAccountAttachmentFailure = (error) => {
  return {
    type: BANK_ACCOUNT_ATTACHMENT_DELETE_FAILURE,
    payload: error,
  };
};

// Bank Account Statement (bank statements with a period)
// Search - data = [{ bankaccountstatement_data: { BankAccount_Id } }]
export const searchBankAccountStatement = (data) => {
  return {
    type: BANK_ACCOUNT_STATEMENT_SEARCH,
    payload: data,
  };
};

export const searchBankAccountStatementSuccess = (data) => {
  return {
    type: BANK_ACCOUNT_STATEMENT_SEARCH_SUCCESS,
    payload: data,
  };
};

export const searchBankAccountStatementFailure = (error) => {
  return {
    type: BANK_ACCOUNT_STATEMENT_SEARCH_FAILURE,
    payload: error,
  };
};

// Delete - data = [Id, ...]
export const deleteBankAccountStatement = (data) => {
  return {
    type: BANK_ACCOUNT_STATEMENT_DELETE,
    payload: data,
  };
};

export const deleteBankAccountStatementSuccess = (data) => {
  return {
    type: BANK_ACCOUNT_STATEMENT_DELETE_SUCCESS,
    payload: data,
  };
};

export const deleteBankAccountStatementFailure = (error) => {
  return {
    type: BANK_ACCOUNT_STATEMENT_DELETE_FAILURE,
    payload: error,
  };
};
